import { useAtomValue, useSetAtom } from 'jotai';

import { PreVisitSummaryCard, PreVisitSummaryCardProps } from '@grow-therapy-team/seedling-components';

import { useTrackEvent } from '../../../segment/segment';
import { drawerStateAtom, isInSessionWithSelectedClientAtom, selectedPatientId } from '../../state';
import { createNudgeOnClickHandlers, getProviderDashboardReferralUri } from '../utils';

/**
 * A wrapper around the {@link PreVisitSummaryCard} that provides it with
 * `nudgeOnClickHandlers`. Intended to be used as the
 * `preVisitSummaryCardComponent` prop to {@link PreVisitSummaryCardConnected}.
 */
export function PreVisitSummaryCardNudgeWrapper({
  nudges,
  ...passThroughProps
}: Omit<PreVisitSummaryCardProps, 'nudgeOnClickHandlers'>) {
  const isInSessionWithSelectedClient = useAtomValue(isInSessionWithSelectedClientAtom);
  // Copied patient ID statement below from the `ClientConsiderationSection`
  const patientId = useAtomValue(selectedPatientId) ?? '';
  const setDrawerState = useSetAtom(drawerStateAtom);
  const { userClicked } = useTrackEvent();

  return (
    <PreVisitSummaryCard
      {...passThroughProps}
      nudges={nudges}
      nudgeOnClickHandlers={
        nudges &&
        createNudgeOnClickHandlers(
          nudges,
          setDrawerState,
          patientId && getProviderDashboardReferralUri(patientId),
          userClicked,
          isInSessionWithSelectedClient,
        )
      }
    />
  );
}
